import Image from '@atoms/Image';
import DoneIcon from '@mui/icons-material/Done';
import { Select, SelectItem } from '@atoms/new/select';
import { Pulse } from '@atoms/Pulse';
import { useHotspot } from '@lib/hooks/useHotSpot';

export type PlatformProps = {
  logo: string;
  title: string;
  order: number;
};

interface PlatformDropdownProps {
  platformDetails?: PlatformProps;
  selectedKeys: Set<string>;
  setSelectedKeys?: (key: any) => void;
}

export const SANDBOX_PLATFORMS = {
  twitch: {
    logo: '/images/twitch-icon.svg',
    title: 'Twitch',
    order: 6,
    slug: 'twitch',
  },
  zoom: {
    logo: '/images/Zoom.svg',
    title: 'Zoom',
    order: 1,
    slug: 'zoom',
  },
  ipa: {
    logo: '/images/in_person.svg',
    title: 'In-person',
    order: 7,
    slug: 'ipa',
  },
  meet: {
    logo: '/images/meet-icon.svg',
    title: 'Google Meet',
    order: 2,
    slug: 'meet',
  },
  youtube: {
    logo: '/images/youtube-icon.svg',
    title: 'YouTube',
    order: 3,
    slug: 'youtube',
  },
  teams: {
    logo: '/images/teams-logo.svg',
    title: 'Microsoft Teams',
    order: 4,
    slug: 'teams',
  },
  streamyard: {
    logo: '/images/streamyard.png',
    title: 'Streamyard',
    order: 12,
    slug: 'streamyard',
  },
  linkedin: {
    logo: '/images/linkedin-icon.svg',
    title: 'LinkedIn',
    order: 11,
    slug: 'linkedin',
  },
  airmeet: {
    logo: '/images/airmeet.svg',
    title: 'Airmeet',
    order: 10,
    slug: 'airmeet',
  },
  restream: {
    logo: '/images/restream.svg',
    title: 'Restream',
    order: 9,
    slug: 'restream',
  },
  kick: {
    logo: '/images/kick.png',
    title: 'Kick',
    order: 8,
    slug: 'kick',
  },
};

export const PlatformDropdown = ({
  selectedKeys,
  setSelectedKeys = () => {},
  platformDetails,
}: PlatformDropdownProps) => {
  const platforms = Object.values(SANDBOX_PLATFORMS).sort(
    (a, b) => a.order - b.order
  );
  const { isHotspotEnabled, handleHotspotClose } = useHotspot(
    'sandbox:platform:dropdown:hotspot'
  );

  return (
    <Select
      selectedKeys={selectedKeys}
      className="w-60"
      endContent={
        <div className="absolute -bottom-2 -right-2">
          <Pulse
            onClose={handleHotspotClose}
            isEnabled={isHotspotEnabled}
            tooltip="Switch between platforms to see StreamAlive in action"
          />
        </div>
      }
      startContent={
        <Image
          width={20}
          height={20}
          src={platformDetails?.logo}
          alt={`${platformDetails?.title}-logo`}
        />
      }
      onSelectionChange={(key: any) => setSelectedKeys(key)}
    >
      {platforms.map((platform) => (
        <SelectItem
          selectedIcon={({ isSelected }) => (
            <div
              className={`w-6 h-6 absolute top-1 right-2 ${
                isSelected ? '' : 'hidden'
              }`}
            >
              <DoneIcon fontSize="small" />
            </div>
          )}
          key={platform.slug}
          startContent={
            <Image
              width={20}
              height={20}
              src={platform.logo}
              alt={`${platform.title}-logo`}
            />
          }
        >
          {platform.title}
        </SelectItem>
      ))}
    </Select>
  );
};
